import http from 'services/http'
import { ref } from '@vue/composition-api'

export default function useHttpPost({ url, sleep }) {
  const response = ref(null)
  const postInProgress = ref(false)

  const errors = ref({})

  const post = async (data) => {
    postInProgress.value = true
    try {
      const request = http.postAuthed(url, data)
      if (sleep) {
        await http.sleep(sleep)
      }
      response.value = await request
      errors.value = {}
      return response.value
    } catch (err) {
      if (err && err.response && err.response.status === 400) {
        errors.value = err.response.data
      }
      throw err
    } finally {
      postInProgress.value = false
    }
  }

  return { response, postInProgress, post, errors }
}
